@if(show) {
  <div class="notification-container" role="status" aria-live="polite">
    <div class="content" [class]="notification.type">
      <span class="icons-outlined icon">
        {{ notification.type === 'success'?
            'check_circle' : notification.type === 'error'? 'error' : 'info'
        }}
      </span>
      <span class="message">{{ notification.message | translate }}</span>
    </div>
    <button class="close-btn" type="button" [attr.aria-label]="'common.close' | translate" (click)="dismiss()">
      <span class="icons-outlined">close</span>
    </button>
  </div>
}
